<form #createSchoolForm="ngForm" name="createSchoolForm" (ngSubmit)="onSubmit()" class="mb-0">
  <div class="d-flex align-items-center justify-content-center gap-1.5 flex-wrap">
    <div *ngIf="logoimg.style.display === 'none'" class="logoimg img-placeholder d-flex align-items-center text-center">
      No Image Added</div>
    <img #logoimg src="{{schooInfo.logoImg}}" alt="Image to be uploaded" class="logoimg object-cover object-center"
      style="display: none;">
    <div class="text-center">
      <button (click)="logo.click()" type="button" id="schoollogoimglabel" class="btn mx-0 mb-1"><i
          class="fa fa-plus"></i> Add School Logo</button>
      <input #logo (change)="handleLogoFileChange($event.target.files)" type="file" name="logo" accept="image/*"
        aria-labelledby="schoollogoimglabel" id="schoollogoimg" class="sr-only">
      <!-- <span class="text-xs">{{settings.moduleImageWidth}} x {{settings.moduleImageHeight}} pixels required</span> -->
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-center gap-1.5 flex-wrap mt-2">
    <div *ngIf="logoimg2.style.display === 'none'"
      class="logoimg img-placeholder d-flex align-items-center text-center">
      No Image Added</div>
    <img #logoimg2 src="{{schooInfo.appLogoImg}}" alt="Image to be uploaded" class="logoimg object-cover object-center"
      style="display: none;">
    <div class="text-center">
      <button (click)="logo2.click()" type="button" id="schoolapplogoimglabel" class="btn btn--dashed mx-0 mb-1"><i
          class="fa fa-plus"></i> Add App Logo </button>
      <input #logo2 (change)="handleAppLogoFileChange($event.target.files)" type="file" name="logo" accept="image/png"
        aria-labelledby="schoolapplogoimglabel" id="schoollogoimg2" class="sr-only">
      <!-- <span class="text-xs">{{settings.moduleImageWidth}} x {{settings.moduleImageHeight}} pixels required</span> -->
    </div>
  </div>
  <div class="mt-5">
    <div class="fieldset fieldset--lg">
      <label class="legend" for="schoolname">School Name <span class="requiredfield">*</span></label>
      <input type="text" [(ngModel)]="schooInfo.schoolName" #schoolName maxlength="100" required name="Name"
        class="text-field" id="schoolname">
    </div>
    <div *ngIf="schooInfo.schoolSubdomain" class="d-flex align-items-center justify-content-center mb-1">
      <p class="form-info-p fieldset--lg">Your school's url: <b><span
            class="text-underline">{{schooInfo.schoolSubdomain}}</span></b>.impata.com</p>
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="domain">Subdomain</label>
      <input type="text" [(ngModel)]="schooInfo.schoolSubdomain" #schoolSubdomain name="Domain" class="text-field"
        id="domain" [attr.readonly]="!this.hasSubdomainFeature ? '' : null">
      <!-- <button id="infotoggle" type="button" data-toggle="dropdown" aria-expanded="false"
        title="This enables a customized url"
        class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"><i
          class="fa fa-info-circle"></i></button> -->
      <!-- <div class="info-popup dropdown-menu p-2">
        <p class="form-info-p">Your school's url: <b><span class="text-underline">{{schooInfo.schoolSubdomain}}</span></b>.impata.com</p>
      </div> -->
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="phone">Phone Number</label>
      <input type="text" minlength="10" [(ngModel)]="schooInfo.schoolNumber" #schoolNumber name="schoolNumber"
        class="text-field" id="phone">
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="schoolemail">Email Address</label>
      <input type="email" [(ngModel)]="schooInfo.schoolEmail" #schoolEmail name="schoolEmail" class="text-field"
        id="schoolemail">
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="schoolemail">Invoice Email Address</label>
      <input type="email" [(ngModel)]="schooInfo.invoiceEmail" #schoolEmail name="invoiceEmail" class="text-field"
        id="invoiceemail">
      <button type="button" data-toggle="dropdown" aria-expanded="false" title="Invoice is sent to the specified email"
        class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"><i
          class="fa fa-info-circle"></i></button>
      <div class="info-popup dropdown-menu p-2">
        <p class="form-info-p">The school's outstanding bill is sent as an invoice to the specified email address</p>
      </div>
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="allowEnroll">Allow Tutor Send Mail</label>
      <select class="text-field" [(ngModel)]=schooInfo.tutorCanSendMail #EnrollAllowed name="CanSendMail"
        id="allowSendMail">
        <option [ngValue]="true" selected>Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="TimeZone">School TimeZone</label>
      <ng-moment-timezone-picker required [(ngModel)]="timeZoneInfo" #timeZoneName name="timeZoneName"
        customPlaceholderText="Select Timezone">
      </ng-moment-timezone-picker>
    </div>
    <div class="fieldset--lg d-flex flex-column flex-md-row m-auto mw-100">
      <div class="fieldset fieldset--lg flex-fill mr-md-3">
        <label class="legend" for="allowEnroll">Allow Students Enrol for Courses</label>
        <select class="text-field" [(ngModel)]=schooInfo.studentsCanEnrollForModules #EnrollAllowed name="EnrollAllowed"
          id="allowEnroll">
          <option [ngValue]="true" selected>Yes</option>
          <option [ngValue]="false">No</option>
        </select>
      </div>
      <div class="fieldset fieldset--lg flex-fill">
        <label class="legend" for="allowEnrollPackages">Allow Students Enrol for Packages</label>
        <select class="text-field" [(ngModel)]=schooInfo.studentsCanEnrollForPackages #EnrollAllowed
          name="EnrollPackagesAllowed" id="allowEnrollPackages">
          <option [ngValue]="true" selected>Yes</option>
          <option [ngValue]="false">No</option>
        </select>
      </div>
    </div>
    <div class="fieldset--lg d-flex flex-column flex-md-row m-auto mw-100">
      <div class="fieldset fieldset--lg flex-fill mr-md-3">
        <label class="legend" for="privateschool">This School is Private</label>
        <select class="text-field" [(ngModel)]=schooInfo.privateSchool #PrivateSchool id="privateschool"
          name="PrivateSchool">
          <option [ngValue]="true" selected>Yes</option>
          <option [ngValue]="false">No</option>
        </select>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Private school"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Private school participant-enrollment is done by the admin. Participants cannot enroll
          </p>
        </div>
      </div>
      <div class="fieldset fieldset--lg flex-fill">
        <label class="legend" for="hideFeesForFreeCourses">Hide Fees for Free Courses</label>
        <select class="text-field" [(ngModel)]=schooInfo.hideFeesForFreeCourses #HideFeesForUnlimitedCourses
          name="hideFeesForFreeCourses" id="hideFeesForFreeCourses">
          <option [ngValue]="true" selected>Yes</option>
          <option [ngValue]="false">No</option>
        </select>
      </div>
    </div>
    <!-- <div class="fieldset fieldset--lg" style="margin-bottom: 15px;">
      <p class="form-info-p">All fees you collect will be settled to the account you specify below</p>
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="bankId">Select Your Bank</label>
      <ng-select [(ngModel)]="schooInfo.bankId" name="bankId" id="bankId" ngDefaultControl #bankIdField>
        <ng-option *ngFor="let bank of banks" [value]="bank.id">{{bank.name}}</ng-option>
      </ng-select>
    </div>
    <div class="fieldset--lg d-flex flex-column flex-md-row m-auto mw-100">
      <div class="fieldset fieldset--lg flex-fill mr-md-3">
        <label class="legend" for="accountName">Account Name</label>
        <input type="text" [(ngModel)]="schooInfo.accountName" #accountName name="accountName" class="text-field" id="accountName">
      </div>
      <div class="fieldset fieldset--lg flex-fill">
        <label class="legend" for="accountNumber">Account Number</label>
        <input type="text" [(ngModel)]="schooInfo.accountNumber" #accountNumber name="accountNumber" class="text-field" id="accountNumber">
      </div>
    </div> -->
    <div class="fieldset fieldset--note mb-0">
      <label class="legend z-1">School Description</label>
      <quill-editor #description name="description" classes="text-reset"></quill-editor>
    </div>
  </div>

  <!-- <div class="mt-5" *ngIf="accountPLans">
    <div class="text-center">
      <h3>Select a Plan for Your School</h3>
      <a class="text-link text-sm" href="https://impata.com/pricing" target="_blank"><i class="fa fa-info-circle"></i> View More</a>
    </div>
    <div class="d-flex justify-content-center gap-1.5 flex-wrap mt-3">
      <div class="card card-block shadow-sm-darker mb-0" *ngFor="let plan of accountPLans">
        <div class="card-body">
          <h4 class="text-center mb-0">
            <div class="font-weight-normal text-primary text-md">{{plan.name}}</div>
            <div class="mt-2 font-weight-700 text-2xl">₦{{util.numberWithCommas(plan.perStudentPrice)}}</div>
            <div class="font-weight-normal text-xs text-body"> monthly / per Student</div>
          </h4>
          <ul class="list-unstyled text-sm mb-4 py-4 border-b-border-line">
            <li class="d-flex align-items-center my-2">
              <span class="mr-2 "><i class="inclusion-icon far fa-check-circle text-primary"></i></span>
              <span>Free Student Enrollment</span>
            </li>
            <li class="d-flex align-items-center my-2">
              <span class="mr-2">
                <i *ngIf="plan.paymentIntegration" class="inclusion-icon far fa-check-circle text-primary" title="Included"></i>
                <i *ngIf="!plan.paymentIntegration" class="inclusion-icon far fa-times-circle text-red" title="Not Included"></i>
              </span>
              <span>Payment Collection</span>
            </li>
            <li class="d-flex align-items-center my-2">
              <span class="mr-2">
                <i *ngIf="plan.mediaStorageSize" class="inclusion-icon far fa-check-circle text-primary" title="Included"></i>
                <i *ngIf="!plan.mediaStorageSize" class="inclusion-icon far fa-times-circle text-red" title="Not Included"></i>
              </span>
              <span><b>{{this.util.convertBytesToGB(plan.mediaStorageSize)}} GB</b> Storage</span>
            </li>
            <li class="d-flex align-items-center my-2">
              <span class="mr-2">
                <i *ngIf="plan.logoCustomization" class="inclusion-icon far fa-check-circle text-primary" title="Included"></i>
                <i *ngIf="!plan.logoCustomization" class="inclusion-icon far fa-times-circle text-red" title="Not Included"></i>
              </span>
              <span>Custom Logo</span>
            </li>
            <li class="d-flex align-items-center my-2">
              <span class="mr-2">
                <i *ngIf="plan.pageCustomization" class="inclusion-icon far fa-check-circle text-primary" title="Included"></i>
                <i *ngIf="!plan.pageCustomization" class="inclusion-icon far fa-times-circle text-red" title="Not Included"></i>
              </span>
              <span>Custom Page Design</span>
            </li>
            <li class="d-flex align-items-center my-2">
              <span class="mr-2">
                <i *ngIf="plan.studentBulkUpload" class="inclusion-icon far fa-check-circle text-primary" title="Included"></i>
                <i *ngIf="!plan.studentBulkUpload" class="inclusion-icon far fa-times-circle text-red" title="Not Included"></i>
              </span>
              <span>Bulk Student Enrollment</span>
            </li>
            <li class="d-flex align-items-center my-2">
              <span class="mr-2">
                <i *ngIf="plan.domainCustomization" class="inclusion-icon far fa-check-circle text-primary" title="Included"></i>
                <i *ngIf="!plan.domainCustomization" class="inclusion-icon far fa-times-circle text-red" title="Not Included"></i>
              </span>
              <span>Custom Domain</span>
            </li>
            <li class="d-flex align-items-center my-2">
              <span class="mr-2">
                <i *ngIf="plan.studentLoginIntegration" class="inclusion-icon far fa-check-circle text-primary" title="Included"></i>
                <i *ngIf="!plan.studentLoginIntegration" class="inclusion-icon far fa-times-circle text-red" title="Not Included"></i>
              </span>
              <span>External Authentication Integration</span>
            </li>
          </ul>
          <div class="text-center">
            <input class="btn w-100 planSlt" [ngClass]="{'btn--dashed': plan.id != this.schooInfo.accountTierId}"  type="button" [attr.data-id]="plan.id" [attr.value]="plan.id != this.schooInfo.accountTierId ? 'Select Plan' : 'Plan Selected'" value="Select Plan"  (click)="onPlanSelect(plan.id)" />
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="selectedPlan > 0 && !this.schooInfo.freePlanSelected" class="mt-5">
      <h3 class="text-center">Enter Billing Information for School</h3>
      <div class="mt-3">
        <div class="fieldset fieldset--lg">
          <label class="legend" for="invoice-name">Invoice Name <span class="text-red">*</span></label>
          <input type="text" minlength="10" [(ngModel)]="schooInfo.billingName" #billingName
            name="billingName" class="text-field" [required]="!this.schooInfo.freePlanSelected" id="invoice-name">
          <p class="form-info-p">Name to show on the invoice</p>
        </div>
        <div class="fieldset fieldset--lg">
          <label class="legend" for="invoice-phone">Invoice Phone <span class="text-red">*</span></label>
          <input type="text" minlength="10" [(ngModel)]="schooInfo.billingPhone" #billingPhone
            name="billingPhone" class="text-field" [required]="!this.schooInfo.freePlanSelected" id="invoice-phone">
          <p class="form-info-p">Phone number to recieve billing alerts</p>
        </div>
        <div class="fieldset fieldset--lg">
          <label class="legend" for="invoice-email">Invoice Email address <span class="text-red">*</span></label>
          <input type="email" [(ngModel)]="schooInfo.billingEmail" #billingEmail name="billingEmail"
            class="text-field" id="invoice-email" [required]="!this.schooInfo.freePlanSelected">
          <p class="form-info-p">Email to send invoice to</p>
        </div>
        <div class="fieldset fieldset--lg">
          <label class="legend" for="invoice-postal-address">Invoice Postal Address</label>
          <textarea rows="3" [(ngModel)]="schooInfo.billingAddress" #billingAddress
            name="billingAddress" class="text-field" id="invoice-postal-address"></textarea>
          <p class="form-info-p">The Address to show on the invoice</p>
        </div>
      </div>
    </div>
  </div> -->

  <div class="d-flex justify-content-center flex-wrap gap-1.5 mt-5">
    <ng-template [ngIf]="!schoolid || schoolid === 0">
      <button class="btn m-0" [disabled]="this.createSchoolForm.invalid" type="submit">Create School</button>
      <button class="btn btn--warning m-0" routerLink="/user/manageschools">Cancel</button>
    </ng-template>
    <ng-template [ngIf]="schoolid && schoolid > 0">
      <button class="btn m-0" [disabled]="this.createSchoolForm.invalid" type="submit">Save</button>
      <button class="btn btn--warning m-0" routerLink="/user/schoolhome">Cancel</button>
    </ng-template>
  </div>
</form>

<div class="modal fade" #externalMediaModal tabindex="-1" role="dialog" aria-labelledby="externalMediaModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="externalMediaModalLabel">Select Media</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-add-external-media #addExternalMediaComponent></app-add-external-media>
      </div>
      <div class="modal-footer justify-content-center gap-1.5">
        <button type="button" class="btn m-0" (click)="externalMediaSelected()"
          [disabled]="!addExternalMediaComponent.mediaurl.trim()">Ok</button>
        <button type="button" class="btn btn--warning m-0" (click)="closeExternalMediaModal()">Close</button>
      </div>
    </div>
  </div>
</div>
